export default __webpack_public_path__ + "static/media/oslogo.4ad676d4.png";